import { actions } from "../../utils/constants"


const initialState = {
    validate: false,
    Beneficiary_Video_count: false,
    Beneficiary_video_data: false,

}

const BeneficiaryReducer = (state = { initialState }, action) => {
    switch (action.type) {
        case actions.BENEFICIARY_VALIDATE:
            return { ...state, validate: action.value }
        case actions.BENEFICIARY_RAWVIDEO_COUNT:
            return { ...state, Beneficiary_Video_count: action.value }
        case actions.BENEFICIARY_RAWVIDEO_DATA:
            return { ...state, Beneficiary_video_data: action.value }
        default:
            return { ...state }
    }
}

export default BeneficiaryReducer